// 이벤트 버스
import { defineStore } from "pinia";
import * as cmUtil from "@/utils/cmUtil";

export const useEventBusStore = defineStore({
  id: "eventBusStore",
  state: () => ({
    isCookiePop: false, // 쿠키 설정
    isCommonPop: false, // 공통 팝업
    systemNoticeYn: "", // 시스템공지 여부
    salesPersonIndex: 0, // 영업사원 선택 인덱스
  }),
  actions: {
    setIsCookiePop(bool) {
      this.isCookiePop = bool;
      //cmUtil.setLocalStorage("gv.isCookiePop", bool);
    },
    setIsCommonPop(bool) {
      this.isCommonPop = bool;
      //cmUtil.setLocalStorage("gv.isCommonPop", bool);
    },
    setSystemNoticeYn(yn) {
      this.systemNoticeYn = yn;
      cmUtil.setLocalStorage("gv.systemNoticeYn", yn);
    },
    setSalesPersonIndex(index) {
      this.salesPersonIndex = index;
      cmUtil.setLocalStorage("gv.salesPersonIndex", index);
    },
  },
});

export const useOrderListStatusStore = defineStore({
  id: "orderListStatusStore",
  state: () => ({
    orderListStatusCd: "", // 주문내역 상태코드
    orderListTabIdx: 0, // 주문내역 탭 인덱스 (0: 주문서, 1: 제품별)
  }),
  actions: {
    setOrderListStatusCd(cd) {
      this.orderListStatusCd = cd;
    },
    setOrderListTabIdx(idx) {
      this.orderListTabIdx = idx;
    },
  },
});

export const useShipmentListStore = defineStore({
  id: "shipmentListStore",
  state: () => ({
    searchFunction: null,
    param: null,
  }),
  actions: {
    registerSearchFunction(fn) {
      this.searchFunction = fn;
    },
    excuteSearchFunction() {
      if (this.searchFunction && this.param) {
        this.searchFunction(this.param);
      }
    },
    setParam(param) {
      this.param = param;
    },
  },
});

export const usePurchaseListStore = defineStore({
  id: "purchaseListStore",
  state: () => ({
    searchFunction: null,
    param: null,
  }),
  actions: {
    registerSearchFunction(fn) {
      this.searchFunction = fn;
    },
    excuteSearchFunction() {
      if (this.searchFunction && this.param) {
        this.searchFunction(this.param);
      }
    },
    setParam(param) {
      this.param = param;
    },
  },
});

export const useOrderListStore = defineStore({
  id: "orderListStore",
  state: () => ({
    itemList: [],
  }),
  actions: {
    setItemList(items) {
      this.itemList = items;
    },
    addItem(item) {
      this.itemList.push({
        ...item,
        quantity: item.quantity,
        itemPrice: item.kbetr,
      });
    },
    removeItem(itemIndex) {
      this.itemList.splice(itemIndex, 1);
    },
    resetItemList() {
      this.itemList = [];
    },
  },
});
